<template>
    <h5-dialog>
        <template v-slot:header v-if="!isIframeUrl">
            <div class="title text-center m-b">用户协议及隐私政策</div>
        </template>
        <div class="xieyi" v-if="isIframeUrl">
            <privacy-policy-content v-if="isShowPrivacyContent" />
            <iframe v-else height="100%" width="100%" :src="iframeUrl" />
        </div>
        <div v-if="!isIframeUrl">
            <div class="phase">
                <div class="phase-title">前言：</div>
                <div v-if="appConfig.game_id == '1113010'" class="phase-content">
                    欢迎您选择出版方北京中科奥科技有限公司以及著作权人北京小奥互动科技股份有限公司共同授权予海南鲸游网络科技有限公司运营所（以下简称为"我们"）提供的游戏！
                    协议是由用户（以下简称为"您"）与我们所提供的产品和服务（包括我们的网站以及我们现在正在提供和将来可能向您提供的网络服务和游戏服务，以下统称为"产品和服务"）所订立的协议。 本协议帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地做出适当的选择。
                </div>
                <div v-else class="phase-content">
                    协议是由用户（以下简称为"您"）与本平台手机游戏平台（以下简称为"我们"）就我们所提供的产品和服务（包括我们的网站以及我们现在正在提供和将来可能向您提供的网络服务和游戏服务，以下统称为"产品和服务"）所订立的协议。 本协议帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地做出适当的选择。
                </div>
                <div class="phase-content">
                    在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以粗体/粗体下划线标识的条款，确保您充分理解和同意之后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。
                </div>
                <div class="phase-content">
                    您同意隐私政策表示您已了解应用提供的功能，以及功能运行所需的必要个人信息，并给予相应的收集使用授权，但并不代表您已单独同意开启附加功能、处理非必要个人信息，相关附加功能的开启、处理非必要个人信息以及处理敏感个人信息，我们会根据您的实际使用情况单独征求您的同意。
                </div>
            </div>
            <div class="phase">
                <div class="phase-title">本隐私政策将帮助您了解以下内容：</div>
                <div class="phase-title">一、适用范围</div>
                <div class="phase-title">二、信息收集及使用</div>
                <div class="phase-title">三、对外提供信息</div>
                <div class="phase-title">四、您的权利</div>
                <div class="phase-title">五、信息的存储</div>
                <div class="phase-title">六、政策的更新</div>
                <div class="phase-title">七、未成年人保护</div>
                <div class="phase-title">八、联系我们</div>
                <div class="phase-title">附录：相关定义</div>
            </div>

            <div class="phase">
                <div class="phase-title">一、适用范围</div>
                <div class="phase-content">
                    本政策适用于服务提供者以网站、客户端、电脑端、小程序以及随技术发展出现的新形态向您提供的各项产品和服务。如我们及关联公司就其向您提供的产品或服务单独设有隐私政策的，则相应产品或服务适用相应隐私政策。
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">二、信息收集及使用</div>
                <div class="phase-content">
                    在您使用我们的产品/服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：
                </div>
                <div class="phase-content">
                    1、为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；
                </div>
                <div class="phase-content">
                    2、为实现向您提供我们产品及/或服务的附加功能，您可选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，不会影响您使用我们的基本功能。
                </div>
                <div class="phase-content">
                    我们在此特别提醒您：我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，故基本/附加功能及对应收集使用的个人信息类型、范围会有所区别，请以具体的产品/服务功能为准。
                    我们会为您提供的各项具体功能场景包括：
                </div>
                <div class="phase-content">
                    （一）帮助您成为我们的用户
                </div>
                <div class="phase-content">
                    1、基础账户服务
                </div>
                <div class="phase-content">
                    我们基于账户为您提供服务。为了创建账户您需要至少向我们提供您的手机号码、手机验证码/密码。如果您拒绝提供上述信息，您可能无法注册账户。
                    如果您使用支付宝、淘宝及（或）第三方账号作为游戏账号关联登录游戏的，我们会收集您使用的第三方账号涉及的唯一标识、昵称、头像、手机号，用于帮助您完成注册和登录，和实现更好的社交体验。您可以在第三方平台中查看和管理以上信息授权情况。您可以自主选择进一步选择填写性别、地区及其他资料以完善您的游戏账号资料。
                </div>
                <div class="phase-content">
                    2、实名认证
                </div>
                <div class="phase-content">
                    为满足相关法律法规政策及相关主管部门的要求，用户需进行实名认证以继续使用和享受游戏服务。我们会在获得您同意或您主动提供的情况下收集您的实名身份信息（包括姓名、身份证号等信息），该信息属于敏感个人信息，拒绝提供实名身份信息可能会导致您无法登录游戏或在使用游戏过程中受到相应限制。
                </div>
                <div class="phase-content">
                    （二）向您提供特定产品或服务
                </div>
                <div class="phase-content">
                    1、为保障您可以正常使用我们的服务，我们需要收集的信息
                </div>
                <div class="phase-content">
                    (1) 日志信息：例如登录日志、物品日志、操作信息、游戏对局信息、好友列表、游戏进程及游戏崩溃记录等，以便您能够在客户端查看您的游戏历史记录，同时用于客服投诉处理及其他游戏安全分析（例如检测盗版、外挂、作弊等不当行为）。为提升您的游戏体验，我们可能把前述信息同步至该游戏后续版本。
                </div>
                <div class="phase-content">
                    (2) 设备及网络信息：设备名称、设备类型和版本、系统版本、IP地址、运行中的进程、设备识别符（如IMEI、SIM卡信息、Android ID、IMSI、MAC地址、设备序列号）、应用ID、网络类型等信息，为保障您正常使用我们的服务，维护游戏基础功能的正常运行。
                </div>
                <div class="phase-content">
                    (3) 支付信息：当您使用消费和充值功能时，您可以选择支付宝、花呗、微信钱包、QQ钱包、苹果支付进行付款（具体以各游戏产品提供的支付通道为准）。我们会将您的游戏账户名、对应的支付机构账户名、订单支付相关信息、订单安全相关设备信息与支付信息服务提供方共享。同时，为使我们及时获悉并确认您的支付进度及状态，为您提供客服与争议解决服务，您同意我们可自上述支付信息服务提供方收集与支付进度相关信息。
                </div>
                <div class="phase-content">
                    2、为体验更多服务或功能，您可能主动向我们提供的信息
                </div>
                <div class="phase-content">
                    (1) 我们可能在您主动提供的情况下，收集您的手机号码、电子邮箱，用于您所参与营销活动的结果通知、游戏故障的报告、以及您所咨询事宜的反馈与沟通，或经您同意向您发送游戏信息（您可以在邮件和短信内通过退订链接直接进行退订）。在您授权同意我们使用地理位置权限后，我们会收集您的地理位置信息，用于匹配最适合的游戏服务器，以便您与附近的玩家匹配、聊天互动等。地理位置信息属于敏感个人信息，拒绝提供该信息只会导致您无法实现与附近的游戏玩家互动，但不影响您正常使用我们产品的其他功能，您也可以随时取消您的地理位置信息授权。
                </div>
                <div class="phase-content">
                    (2) 如您希望通过文字、图片、语音（如有）、视频（如有）与其他游戏玩家互动，在您授权同意后，游戏会访问您的照片或存储文件、麦克风，为您提供截图保存、图片上传、语音聊天等功能。如果您拒绝授权将无法使用对应功能，但不影响您正常使用其他功能，您也可以随时取消相关权限授权。我们可能会收集上述信息，以便用于保存并协助您发送的上述信息，此外为满足相关法律法规政策的要求，我们需要过滤色情、暴力、政治、辱骂、恶意广告等不当内容，以维护健康绿色的游戏环境。
                </div>
                <div class="phase-content">
                    （三）客服及争议处理
                </div>
                <div class="phase-content">
                    当您与我们联系或提出售中、售后、争议纠纷处理申请时，为了保障您的账户及系统安全，我们需要您提供必要的个人信息以核验您的身份。
                    为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的沟通、通信/通话记录及相关内容（包括账户信息、游戏进程信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息）。如果您针对具体支付和充值情况进行咨询、投诉或提供建议的，我们会使用您的账户信息和支付信息。
                    为了提供服务及改进服务质量的合理需要，我们还可能使用您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。
                </div>
                <div class="phase-content">
                    （四）为您提供安全保障
                </div>
                <div class="phase-content">
                    为提高您使用我们服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入风险，更准确地识别违反法律法规或相关协议、规则的情况，我们在应用程序中嵌入我们关联公司开发的应用安全SDK收集您的设备信息、日志信息，并可能使用或整合您的会员信息、交易信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息。为了预防恶意程序、保障运营质量及效率,我们会在应用后台运行期间收集MAC地址、SIM卡信息、Android ID、IMEI、ICCID、设备序列号及其他设备标识符、安装的应用信息、正在运行中的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源，来综合判断您账户风险、进行身份验证、检测外挂作弊及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
                </div>
                <div class="phase-content">
                    （五）为您提供的其他附加服务
                </div>
                <div class="phase-content">
                    1、基于系统权限的附加服务
                </div>
                <div class="phase-content">
                    为向您提供更便捷、更优质的产品及/或服务，努力提升您的体验，我们在向您提供的附加服务中可能会通过开启系统权限以收集和使用您的个人信息。如果您不同意开启相关权限，不会影响您使用的基本服务，但您可能无法获得这些附加服务给您带来的用户体验。
                    您可自行决定这些权限随时的开启或关闭。
                    请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
                    您可点击此处查看各游戏产品应用权限申请与使用情况说明。
                </div>
                <div class="phase-content">
                    2、Cookie和同类技术的服务
                </div>
                <div class="phase-content">
                    Cookie和同类设备信息标识技术是互联网中普遍使用的技术。当您使用我们的服务时，我们可能会使用相关技术向您的设备发送一个或多个 Cookie 或匿名标识符（以下简称"Cookie"），以收集、标识和存储您访问、使用本产品时的信息。我们承诺，不会将 Cookie 用于本隐私政策所述目的之外的任何其他用途。我们使用 Cookie 主要为了保障产品与服务的安全、高效运转，可以使我们确认您账户与交易的安全状态，排查崩溃、延迟的相关异常情况，帮助您省去重复您填写表单、输入搜索内容的步骤和流程。
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">三、对外提供信息</div>
                <div class="phase-content">
                    （一）共享
                </div>
                <div class="phase-content">
                    我们不会与以外的公司、组织和个人共享您的个人信息，但以下情况除外：
                </div>
                <div class="phase-content">
                    1、履行法定义务所必需的共享：我们可能会根据法律法规规定、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行的必需，共享您的个人信息。
                </div>
                <div class="phase-content">
                    2、取得您同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
                </div>
                <div class="phase-content">
                    3、为订立、履行您作为一方当事人的合同所必需的情况下的共享：为保障游戏运行并实现特定功能，游戏中部分服务由我们的关联方或其他第三方提供服务。我们会审慎选择第三方和第三方服务，并督促相关第三方按照本隐私政策或另行与您达成的约定收集和使用您的个人信息，并采取适当的安全技术和管理措施保障您的个人信息安全。
                </div>
                <div class="phase-content">
                    4、与关联公司间共享：为便于我们与关联公司共同向您提供部分服务，基于账户向您提供产品和服务，保护关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束，如果我们共享您的敏感个人信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
                </div>
                <div class="phase-content">
                    5、代理产品：我们的业务包含代理发行的游戏产品，我们可能与开发主体或相关第三方共享您在游戏中产生的日志及相关信息（如登录日志等），用于游戏安全分析，完善游戏服务，进一步优化用户的游戏体验。如我们共享前述信息的，我们会严格按照相关法律规定采取相应的合规措施，确保个人信息共享符合相应法律规定。前述合规措施包括但不限于要求开发主体或相关第三方严格遵守本指引与您达成的约定收集和使用您的个人信息，督促开发主体或相关第三方采取适当的安全技术和管理措施保障您的个人信息安全等。
                </div>
                <div class="phase-content">
                    6、广告推送：我们部分游戏产品将提供广告推送服务。为评估、优化广告投放效果等目的，我们需要向广告主及其代理商等第三方合作伙伴共享您的部分数据，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。提供广告推送的产品如何与广告主等第三方共享数据，请详见该产品在各游戏产品接入的SDK详情中披露的内容。
                    请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至敏感个人信息。请您更加谨慎地考虑并做出决定。
                </div>
                <div class="phase-content">
                    （二）委托处理
                </div>
                <div class="phase-content">
                    我们可能委托授权合作伙伴处理您的个人信息，以便授权合作伙伴代表我们为您提供某些服务或履行职能。我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作伙伴将您的信息用于我们未委托的用途，其将单独征得您的同意。
                </div>
                <div class="phase-content">
                    目前，我们委托的授权合作伙伴包括以下类型：
                </div>
                <div class="phase-content">
                    1、 广告投放、分析服务类的授权合作伙伴。我们会在采用行业通用的安全技术前提下，委托这些合作伙伴处理与广告投放、覆盖面和有效性相关的信息。我们不会将您的个人身份信息委托合作伙伴处理。
                </div>
                <div class="phase-content">
                    2、 供应商、服务提供商和其他合作伙伴。我们将信息委托给支持我们业务的供应商、服务提供商和其他合作伙伴处理，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、提供客户服务、支付便利或进行学术研究和调查。
                    为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。授权合作伙伴单独取得您同意的除外。
                    您可点击此处查看各游戏产品接入的SDK详情。
                </div>
                <div class="phase-content">
                    （三）转让
                </div>
                <div class="phase-content">
                    如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方将继续履行本政策及其他法定义务。接收方变更原先的处理目的、处理方式的，会重新取得您的同意。
                </div>
                <div class="phase-content">
                    （四）公开披露
                </div>
                <div class="phase-content">
                    我们仅会在以下情况下，公开披露您的个人信息：
                </div>
                <div class="phase-content">
                    1、 基于您的主动选择及其他单独同意的情况下，我们可能会公开披露您的个人信息；
                </div>
                <div class="phase-content">
                    2、 如果我们确定您出现违反法律法规或严重违反相关协议及规则的情况，或为保护用户或公众的人身财产安全免遭侵害，我们可能披露关于您的个人信息，包括相关违规行为以及已对您采取的措施。
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">四、您的权利</div>
                <div class="phase-content">
                    您可以通过以下方式查阅和管理您的信息，我们会在符合法律法规要求的情形下响应您的请求：
                </div>
                <div class="phase-content">
                    （一）查阅、复制、更正和补充
                </div>
                <div class="phase-content">
                    您有权通过以下方式查阅、复制、更正和补充您的信息：
                </div>
                <div class="phase-content">
                    1、 您可以在您使用的产品中查询和访问您的账号基础信息（头像、昵称，以及其他您选择填写的个人信息）、游戏历史信息（如角色等级、成就、战绩，以及各个产品特定的游戏信息）。
                </div>
                <div class="phase-content">
                    2、 您可以在产品内，根据产品实际情况按照提示查询有关您使用产品和服务的信息，具体请见各产品"用户中心"或"用户"界面说明。
                </div>
                <div class="phase-content">
                    3、 如您有其他查阅、复制、更正、补充的需求或您在使用产品相应功能过程中有疑惑或困难，您也可以通过第八条所述的联系方式与我们联系，我们会及时为您处理。但为保障账号和个人信息安全，我们可能会对您的身份、账号安全状态等进行验证。对于您合理的请求，我们将尽可能予以支持。对于超出我们个人信息存储范围、超过合理限度，或者响应您的请求将导致您或其他第三方合法权益严重受损等情形下，我们可能无法响应您的请求。
                </div>
                <div class="phase-content">
                    （二）删除和注销账户
                </div>
                <div class="phase-content">
                    您可以通过"（一）查阅、复制、更正和补充您的信息"列明的路径调整您的部分信息，或申请注销账户删除您的全部信息。
                </div>
                <div class="phase-content">
                    因部分个人信息收集和使用对应我们服务的基础功能，如您希望部分删除可能导致我们无法为您提供服务，在此情形下，如您仍希望删除，您可以通过申请账号注销实现您的需求。您可以通过以下方式申请注销您的账户：
                </div>
                <div class="phase-content">
                    1、 您可以在产品"用户中心"或"用户"-"账号注销"或产品内另行告知的其他渠道申请进行账号注销。
                </div>
                <div class="phase-content">
                    2、 您可以通过客服联系，申请注销您的账户。
                </div>
                <div class="phase-content">
                    在您主动注销账户之后，我们将停止为您提供产品或服务，并根据适用法律的要求删除或匿名化处理您的个人信息。
                </div>
                <div class="phase-content">
                    （三）改变授权范围
                </div>
                <div class="phase-content">
                    您可以通过以下方式改变或者撤回您授权我们收集和处理您的个人信息的范围：
                </div>
                <div class="phase-content">
                    1、 您可以通过注销账户、关闭或开启产品内部功能、关闭或开启特定产品获取的设备权限（具体权限因用户使用的设备型号、系统版本不同而存在差异，例如：iOS系统可以通过"设置-隐私"中管理相应设备授权；游戏内通过"更多-系统-隐私"管理相应设备权限），变更对我们收集和使用您的个人信息的授权范围。
                </div>
                <div class="phase-content">
                    2、 对于您无法直接通过上述方式设置的授权，您可以通过客服联系进行修改。
                    但请注意，对于部分类型的个人信息，例如实现产品基本功能所必须的信息或者我们履行法律法规规定的义务所必需的信息，我们可能无法响应您改变授权范围的请求。在此情形下，如您仍希望撤回相关授权，您可以通过申请账号注销实现该需求。当您撤回授权后，我们将不再处理相应的个人信息。但您撤回授权的决定，不会影响我们此前基于您的授权而开展的个人信息处理。
                </div>
                <div class="phase-content">
                    （四）响应您的上述请求
                </div>
                <div class="phase-content">
                    对于您或可能的您的监护人、近亲属及其他有权主体向我们提出上述请求，以及中华人民共和国法律与其他适用法律规定的您的相关个人信息权利，您可以通过客服联系我们或直接向我们的个人信息保护专职部门发起投诉。我们将在15天内做出答复。
                </div>
                <div class="phase-content">
                    为保障您的账户安全和您的个人信息安全，您向我们提出上述请求时，我们可能会先验证您的身份（如增加账户核验、要求您提供书面请求或其他合理方式），然后再处理您的请求。
                    对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无合理理由重复申请的信息，或者需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">五、信息的存储</div>
                <div class="phase-content">
                    （一）存储期限
                </div>
                <div class="phase-content">
                    我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求。如我们终止服务或运营，我们将及时停止继续收集您个人信息的活动，同时会遵守相关法律法规要求提前向您通知。
                </div>
                <div class="phase-content">
                    我们判断个人信息的存储期限主要依据以下标准：
                </div>
                <div class="phase-content">
                    1、 完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；
                </div>
                <div class="phase-content">
                    2、 保证我们为您提供服务的安全和质量；
                </div>
                <div class="phase-content">
                    3、 您是否同意更长的留存期间；
                </div>
                <div class="phase-content">
                    4、 是否存在关于保留期限的其他特别约定或法律法规规定（如：《民法典》中有关诉讼时效的规定）。
                </div>
                <div class="phase-content">
                    在超出保留期间或终止服务/运营后，我们会根据适用法律的要求删除或匿名化处理您的个人信息。
                </div>
                <div class="phase-content">
                    （二）存储位置
                </div>
                <div class="phase-content">
                    我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。以下情形下，我们会在履行法律规定的义务后，向可能的境外实体提供您的个人信息：
                </div>
                <div class="phase-content">
                    1、 适用的法律有明确规定；
                </div>
                <div class="phase-content">
                    2、 获得您的单独同意；
                </div>
                <div class="phase-content">
                    3、 您作为一方当事人的跨境电子商务交易及其他类型合同订立和履行所必需的。
                    针对以上情形，我们会按照本政策依法保护您的个人信息安全。
                </div>
                <div class="phase-content">
                    （三）存储安全
                </div>
                <div class="phase-content">
                    1、数据保护技术措施
                </div>
                <div class="phase-content">
                    我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理等；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。
                </div>
                <div class="phase-content">
                    2、数据保护管理组织措施
                </div>
                <div class="phase-content">
                    我们建立了行业内先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理及产品技术的维度提升个人信息的安全性。我们已经设置了个人信息保护专职部门。我们通过培训课程和考试，不断加强员工对于保护个人信息重要性的认识。
                </div>
                <div class="phase-content">
                    3、个人信息安全事件的响应
                </div>
                <div class="phase-content">
                    如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们会及时启动应急预案，采取合理必要的措施，以尽可能降低对您个人的影响。如发生个人信息安全事件，我们还将按照法律法规的要求向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将以短信、电话、推送通知及其他合理渠道告知您，难以逐一告知的，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
                </div>
                <div class="phase-content">
                    4、账户安全风险的防范
                </div>
                <div class="phase-content">
                    在使用和享受游戏互动服务时，您不可避免地要向其他玩家或好友对方披露自己的账号和游戏信息（账号头像、角色名称、等级、成就、战绩）。此外，您也可以通过我们的服务与第三方建立沟通、交流信息或分析内容。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，不轻信通过其他交易工具进行交易，以免信息被窃取甚至遭遇电信网络诈骗。
                    如您担心自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们的客服以便我们根据您的申请采取相应措施。
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">六、政策的更新</div>
                <div class="phase-content">
                    为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术。在新的服务及业务流程变更时，我们可能会更新我们的隐私政策以告知您具体的变化。但未经您明确同意，我们不会限制您按照本政策所享有的权利。我们会在专门页面上发布对本政策所做的任何变更。
                </div>
                <div class="phase-content">
                    对于重大变更，我们还会提供更为显著的通知（包括我们会通过官网和游戏内进行通知或向您提供弹窗提示）。
                </div>
                <div class="phase-content">
                    本政策所指的重大变更包括但不限于：
                </div>
                <div class="phase-content">
                    1、产品的业务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；
                </div>
                <div class="phase-content">
                    2、业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；
                </div>
                <div class="phase-content">
                    3、个人信息共享或公开披露的主要对象发生变化；
                </div>
                <div class="phase-content">
                    4、用户个人信息权利及其行使方式发生重大变化；
                </div>
                <div class="phase-content">
                    5、处理个人信息保护负责人的联络方式及投诉渠道发生变化时；
                </div>
                <div class="phase-content">
                    6、个人信息保护影响评估报告表明产品存在对个人权益有重大影响时。
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">七、未成年人保护</div>
                <div class="phase-content">
                    在游戏娱乐活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。
                </div>
                <div class="phase-content">
                    如果您是14周岁以下儿童的，在您使用我们的服务前，您和您的监护人应仔细阅读我们专门制定的《儿童个人信息保护规则》，确保在取得监护人对《儿童个人信息保护规则》的同意后，您才可在监护人的指导下使用我们的服务，确保您在使用我们的服务和进行交易时的安全。
                </div>
                <div class="phase-content">
                    若您是儿童的父母或其他监护人，请您关注儿童是否是在取得您的授权同意之后使用我们的服务。如您对儿童的个人信息有疑问，请与我们的个人信息保护专职部门联系。
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">八、联系我们</div>
                <div class="phase-content">
                    您可以通过以下方式与我们联系，我们将在15天内回复您的请求：
                </div>
                <div class="phase-content">
                    1、如您对本政策内容有任何疑问、意见或建议，您可通过游戏内在线客服随时与我们联系；
                    需注意的是，我们可能不会回复与本政策或您的个人信息权利无关的问题。
                    如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。
                </div>
                <div class="phase-content">
                    附录：相关定义
                </div>
                <div class="phase-content">
                    关联公司：是指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、合法机构以及上述公司、合法机构的合法继承人。控制是指（1）直接或间接持有过半数的投票权；或（2）直接或间接享有过半数的可分配利润；或（3）直接或间接控制董事会半数以上的成员的组成；或（4）直接或间接持有半数的注册资本。
                </div>
                <div class="phase-content">
                    个人信息：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息,不包括匿名化处理后的信息。
                </div>
                <div class="phase-content">
                    敏感个人信息：敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹信息，以及不满十四周岁未成年人的个人信息。
                </div>
                <div class="phase-content">
                    儿童：指不满十四周岁的未成年人。
                </div>
                <div class="phase-content">
                    设备信息：包括设备标识符（IMEI、IDFA、Android ID、MAC、OAID、IMSI、BSSID、SSID、MEID、SIM卡序列号、设备序列号）、应用信息（运行中的进程、应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息），设备网络环境信息（IP地址，WiFi信息，基站信息及其他网络相关信息）。以产品实际采集情况为准。
                </div>
                <div class="phase-content">
                    日志信息：包括登录日志、物品日志、操作信息、游戏对局信息、交友记录、浏览记录、点击查看记录、搜索查询记录、关注分享信息、发布信息，以及IP地址、设备类型、电信运营商、使用语言、访问日期和时间。
                </div>
                <div class="phase-content">
                    去标识化：指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。
                </div>
                <div class="phase-content">
                    匿名化：指个人信息经过处理无法识别特定自然人且不能复原的过程。
                </div>
            </div>

            <div class="phase" v-if="appConfig.game_id == '1113010'">
                <div class="phase-title" style="text-align: right;">海南鲸游网络科技有限公司</div>
            </div>
        </div>
        <template v-slot:footer>
            <button class="btn btn-primary btn-block" @click="handleAgree">{{ $t('同意') }}</button>
        </template>
    </h5-dialog>
</template>

<script>
import { mapState } from 'vuex'
import H5Dialog from './H5Dialog'
import PrivacyPolicyContent from './PrivacyPolicyContent'

export default {
    name: 'UserAgreement',
    components: { H5Dialog, PrivacyPolicyContent },
    computed: {
        ...mapState({
            appConfig: state => state.app.appConfig,
        }),
        isIframeUrl() {
            return true
        },
        isShowPrivacyContent() {
            return ['1123023', '1123026'].includes(`${this.appConfig.game_id}`)
        },
        iframeUrl() {
            // 1123039（34包）、1123038（谷歌6包）使用同一份 starride 隐私政策
            if (['1123038', '1123039'].includes(`${this.appConfig.game_id}`)) {
                return 'https://www.starride.top/privacy.html'
            }
            return 'https://staticxk.3698k.com/html/haiwai.html'
        }
    },
    methods: {
        handleAgree() {
            this.$emit('agree')
        },
    },
}
</script>

<style scoped>
    .phase {
        font-size: 14px;
        margin-bottom: 12px;
    }

    .phase-title {
        font-weight: 600;
    }

    .phase-content {
        text-indent: 2rem;
        margin-bottom: 8px;
    }

    .phase-content .phase-content {
        text-indent: 1rem;
        padding-left: 1rem;
    }

    .title {
        font-size: 22px;
        font-weight: 600;
        width: 100%;
    }

    .xieyi {
        height: 70vh;
    }

    .xieyi iframe {
        border: none;
    }

    .privacy-content {
        height: 100%;
        padding: 20px;
        background-color: #fff;
    }

    .privacy-title {
        font-size: 24px;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 16px;
        text-align: center;
        border-bottom: 2px solid #1890ff;
        padding-bottom: 12px;
    }

    .privacy-intro {
        font-size: 14px;
        line-height: 1.8;
        color: #666;
        margin-bottom: 24px;
        padding: 16px;
        background-color: #f5f5f5;
        border-radius: 8px;
        border-left: 4px solid #1890ff;
    }

    .privacy-section {
        margin-bottom: 24px;
    }

    .privacy-section h2 {
        font-size: 18px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .privacy-section h3 {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        margin-top: 16px;
        margin-bottom: 10px;
    }

    .privacy-section p {
        font-size: 14px;
        line-height: 1.8;
        color: #333;
        margin-bottom: 10px;
    }

    .privacy-section ul {
        margin: 10px 0 10px 20px;
        padding-left: 0;
    }

    .privacy-section li {
        font-size: 14px;
        line-height: 1.8;
        color: #333;
        margin-bottom: 6px;
        list-style-type: disc;
    }

    .contact-info {
        font-size: 14px;
        color: #333;
        margin: 8px 0;
    }

    .contact-info a {
        color: #1890ff;
        text-decoration: none;
    }

    .contact-info a:hover {
        text-decoration: underline;
    }

    .effective-date {
        margin-top: 30px;
        padding-top: 16px;
        border-top: 2px solid #e8e8e8;
        text-align: center;
    }

    .effective-date p {
        font-size: 14px;
        color: #666;
    }
</style>
